import React from "react";
import { object } from "prop-types";
import { connect } from "react-redux";
import get from "lodash/get";

import "./social-share.m.css";
import Whatsapp from "../../atoms/social-media-icons/Whatsapp";
import Facebook from "../../atoms/social-media-icons/Facebook";
import Twitter from "../../atoms/social-media-icons/Twitter";
import Telegram from "../../atoms/social-media-icons/Telegram";
import Youtube from "../../atoms/social-media-icons/Youtube";
import Instagram from "../../atoms/social-media-icons/Instagram";

const SocialShareIcons = ({ socialLinks, socials }) => {
  if (!socialLinks) {
    return null;
  }

  const list = [
    {
      Type: <Whatsapp height="18px" width="18px" color="black" isShareRequired={false} />,
      url: socials && socials.whatsapp ? socials.whatsapp.url : socialLinks["whatsapp-url"],
      name: "Facebook"
    },
    {
      Type: <Facebook height="18px" width="18px" color="black" isShareRequired={false} />,
      url: socials && socials.facebook ? socials.facebook.url : socialLinks["facebook-url"],
      name: "Facebook"
    },
    {
      Type: <Twitter height="18px" width="18px" color="black" isShareRequired={false} />,
      url: socials && socials.twitter ? socials.twitter.url : socialLinks["twitter-url"],
      name: "Twitter"
    },
    {
      Type: <Instagram height="18px" width="18px" color="black" isShareRequired={false} />,
      url: socials && socials.instagram ? socials.instagram.url : socialLinks["instagram-url"],
      name: "Instagram"
    },
    {
      Type: <Youtube height="18px" width="18px" color="black" isShareRequired={false} />,
      url: socials && socials.youtube ? socials.youtube.url : socialLinks["youtube-url"],
      name: "Youtube"
    },
    {
      Type: <Telegram height="18px" width="18px" color="black" isShareRequired={false} />,
      url: socials && socials.telegram ? socials.telegram.url : socialLinks["telegram-url"],
      name: "Youtube"
    }
  ];

  return (
    <div styleName="wrapper" className="social-icons-wrapper">
      {list.map(({ url, Type, name }, index) => (
        <a
          href={url}
          key={index}
          styleName="social-link-item"
          className="social-link-item"
          target="_blank"
          rel="nofollow noreferrer"
        >
          {Type}
        </a>
      ))}
    </div>
  );
};

SocialShareIcons.propTypes = {
  socialLinks: object,
  socials: object
};

const mapStateToProps = (state) => ({
  socialLinks: get(state, ["qt", "config", "social-links"], {})
});

export default connect(mapStateToProps, null)(SocialShareIcons);
